<template>
  <template v-if="isSelected">
    <div class="col-sm-12 col-lg-8 col-xl-4 transportation-tickets-container__forward-back m-1 d-flex flex-column align-items-center justify-content-center p-0">
      <TransportationTicketCardComponent
          :transportation="data"
          :trip-date="tripDate"
          :ticket-title="title"
          :route-string="route">
      </TransportationTicketCardComponent>
    </div>
  </template>
  <template v-else>
    <div class="col-4 transportation-tickets-container__forward-back m-1 d-flex flex-column align-items-center justify-content-center">
      <img :src="displayProps.imgUrl" alt="" class="transportation-tickets-container__forward-back__arrow">
      <div class="transportation-tickets-container__forward-back__text">{{ $t(displayProps.placeholder) }}</div>
    </div>
  </template>
</template>

<script lang="ts">
import {defineComponent, type PropType} from "vue";
import {routesConst} from "../../routes";
// @ts-ignore
import TransportationTicketCardComponent from "../transportationTicketCard/TransportationTicketCardComponent";
import type {IApiResponseTransportation} from "@/interfaces/apiResponseInterfaces/IApiResponseTransportation.interface";
import type { ITicket } from "@/interfaces/ITicket.interface";


export default defineComponent({
  name: 'TransportationTicketComponent',
  components: {
    TransportationTicketCardComponent
  },

  props: {
    forwardTicket: {
      type: Object as  PropType<ITicket>,
      default: {
        transportationId: null,
        isSelected: false,
        data: null,
        tripDate: null
      },
      required: false
    },
    backTicket: {
      type: Object as  PropType<ITicket>,
      default: {
        transportationId: null,
        isSelected: false,
        data: null,
        tripDate: null
      },
      required: false
    },
    isForwardTicket: {
      type: Boolean
    },
    displayProps: {
      type: Object as PropType<{imgUrl: string, placeholder: string}>
    }
  },

  data() {
    return {
      routesConst: routesConst
    }
  },

  computed: {
    isSelected(): boolean {
      return this.forwardTicket.isSelected || this.backTicket.isSelected;
    },

    data(): IApiResponseTransportation | null {
      return this.isForwardTicket ? this.forwardTicket.data : this.backTicket.data;
    },

    tripDate(): Date|null {
      return this.isForwardTicket ? this.forwardTicket.tripDate : this.backTicket.tripDate;
    },

    title(): string {
      return this.isForwardTicket ? 'forward_ticket' : 'back_ticket';
    },

    route(): string {
      return this.isForwardTicket ? routesConst.ROUND_TRIP_FIRST_STEP : routesConst.ROUND_TRIP_SECOND_STEP;
    }
  }

})
</script>

<style scoped lang="scss">
@import './transportationTicket.scss';

</style>